import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import '../style/Components.css';

interface LoadingProps {
    open: boolean;
}

const Loading: React.FC<LoadingProps> = ({ open }) => {
    if (!open) return null;

    return (
        <Box className='loading_centerBox'>
            <CircularProgress className='primaryBlueColor' />
            <Box ml={2} className='primaryBlueColor'>
                Loading...
            </Box>
        </Box >
    );
};

export default Loading;
